import { render, staticRenderFns } from "./PrescriptionDetails.template.vue?vue&type=template&id=2790852c&scoped=true&"
var script = {}
import style0 from "./PrescriptionDetails.template.vue?vue&type=style&index=0&id=2790852c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2790852c",
  null
  
)

export default component.exports